import { render, staticRenderFns } from "./link-viewer.vue?vue&type=template&id=537d7e82&scoped=true"
import script from "./link-viewer.vue?vue&type=script&lang=js"
export * from "./link-viewer.vue?vue&type=script&lang=js"
import style0 from "./link-viewer.vue?vue&type=style&index=0&id=537d7e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d7e82",
  null
  
)

export default component.exports